import { Injectable } from '@angular/core';
import { CustomerSocketService } from '@events/customer/customer-socket.service';
import { ChangeOperationCollectionEventI } from '@interfaces/change-operation-collection-event.interface';
import { BehaviorSubject } from 'rxjs';
import { ChannelI } from '@interfaces/channel.interface';

@Injectable({
  providedIn: 'root',
})
export class TemplatesSocketService {
  private eventName = 'templates-change';
  private changeSubject = new BehaviorSubject<ChangeOperationCollectionEventI<ChannelI> | null>(null);
  public change$ = this.changeSubject.asObservable();
  constructor(private socketService: CustomerSocketService) {}
  public init() {
    this.socketService.init();
    this.socketService?.socket?.on(this.eventName, (payload: ChangeOperationCollectionEventI<ChannelI>) => {
      this.changeSubject.next(payload);
    });
  }
}
